const truncateTextWithEllipsis = (
  text: string,
  maxLength: number,
  titleCase?: boolean
) => {
  let processedText = text;

  if (titleCase) {
    processedText = text
      .toLowerCase()
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  const textSpace = processedText.replace(/\s/g, '');
  if (textSpace.length > maxLength) {
    return processedText.slice(0, maxLength).trim().concat('...');
  }
  return processedText;
};
export default truncateTextWithEllipsis;
